<template>
  <div
    ref="storelist"
    role="button"
    class="relative selection:flex items-center w-full p-0 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 hover:bg-opacity-80 hover:text-main-900 focus:bg-main-50 focus:bg-opacity-80 focus:text-main-900 active:bg-main-50 active:bg-opacity-80 active:text-main-900 dark:hover:bg-gray-700 dark:hover:text-gray-100 dark:focus:bg-gray-700 dark:focus:text-gray-100 dark:active:bg-gray-700 dark:active:text-gray-100"
  >
    <!-- Toggle Button -->
    <button
      @click="toggleMenu"
      type="button"
      class="flex items-center justify-between w-full p-3 text-xl antialiased font-semibold leading-snug text-left transition-colors border-b-0 select-none border-b-main-100 text-main-700 hover:text-main-900 dark:text-gray-300 dark:hover:text-gray-100"
    >
      <!-- Store Icon -->
      <div class="grid h-5 w-5 relative mr-4 place-items-center">
        <i class="fa-solid fa-shop text-[16px]"></i>
      </div>

      <!-- Selected Store Name -->
      <p
        class="block mr-auto text-base antialiased font-normal leading-relaxed text-main-900 text-ellipsis overflow-hidden whitespace-nowrap dark:text-gray-200"
      >
        {{ selectedStore?.store_name || "Select a store" }}
      </p>

      <!-- Chevron Icon -->
      <i
        :class="{ 'rotate-90': isOpen }"
        class="fa-solid fa-chevron-right text-[12px] ml-4 transition-transform duration-300"
      ></i>
    </button>

    <!-- Dropdown Menu -->
    <ul
      v-show="isOpen"
      ref="menu"
      class="absolute landscape:mt-1 z-10 w-full overflow-auto rounded-md border border-main-50 bg-white p-3 text-sm font-normal text-main-500 shadow-lg shadow-blue-gray-500/10 focus:outline-none transition-all duration-300 ease-in-out dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
    >
      <!-- Preview Store Link -->
      <li
        role="button"
        class="w-full dark:bg-sub-900 cursor-pointer select-none rounded-md px-3 pt-[9px] pb-2 text-start leading-tight transition-all hover:bg-main-50 hover:bg-opacity-80 hover:text-main-900 focus:bg-main-50 focus:bg-opacity-80 focus:text-main-900 active:bg-main-50 active:bg-opacity-80 active:text-main-900 dark:hover:bg-gray-700 dark:hover:text-gray-100 dark:focus:bg-gray-700 dark:focus:text-gray-100 dark:active:bg-gray-700 dark:active:text-gray-100 mb-1"
      >
        <a class="no-underline w-full flex justify-between">
          Preview Store
          <i class="fa-solid fa-arrow-up-long text-[12px] ml-4 rotate-45"></i>
        </a>
      </li>

      <!-- Store List -->
      <li
        v-for="store in filteredStores"
        :key="store.ID"
        @click="setStore(store)"
        role="menuitem"
        class="block w-full cursor-pointer select-none rounded-md px-3 pt-[9px] pb-2 text-start leading-tight transition-all hover:bg-main-50 hover:bg-opacity-80 hover:text-main-900 focus:bg-main-50 focus:bg-opacity-80 focus:text-main-900 active:bg-main-50 active:bg-opacity-80 active:text-main-900 dark:hover:bg-gray-700 dark:hover:text-gray-100 dark:focus:bg-gray-700 dark:focus:text-gray-100 dark:active:bg-gray-700 dark:active:text-gray-100 mb-1"
      >
        {{ store.store_name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "StoreListComponent",
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selectedStore() {
      return this.$store.state.selectedStore;
    },
    filteredStores() {
      const allStores = this.$store.getters.allStores;
      return allStores.filter((store) => store.id !== this.selectedStore?.id);
    },
  },
  watch: {
    "$store.getters.isAdmin"(newVal) {
      this.$store.commit("setIsAdmin", newVal);
    },
  },
  mounted() {
    console.log("Selected Store:", this.selectedStore.store_name);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    async setStore(store) {
      this.$store.commit("setSelectedStore", store);
      this.$store.commit(
        "setRequiresSetup",
        store.store_name === "Default Store"
      );
      await this.$store.dispatch("getIsUserAdmin");
      this.isOpen = false;
      this.$emit("closeSidebar");
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
    handleClickOutside(event) {
      const storelist = this.$refs.storelist;
      const menu = this.$refs.menu;

      if (storelist && menu && !storelist.contains(event.target)) {
        this.closeMenu();
      }
    },
  },
};
</script>
